import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { Card, Table } from 'react-bootstrap'

export const DashboardTable = ({ title, subheader, tableHeader, tableBody, tableStyles, tableClassname, dataLength }) => {
    return (
        <Card className={` shadow-sm rounded-3 h-100 p-0 w-100 ${tableClassname}`} style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3", minWidth: 0, overflow: "hidden", ...tableStyles }}>
            <Card.Body className="p-3 flex-grow-1 listStyleForContact" style={{ minWidth: 0, overflowX: "hidden", overflowY: "auto" }}>
                <div>
                    <span className="d-block mb-0 pb-0" style={{ fontWeight: 500, fontSize: '16px', }}>
                        {/* Today's Activity */}
                        {title}
                    </span>
                    <span className="text-muted d-block" style={{ fontSize: "11px" }}>
                        {subheader}
                    </span>
                </div>
                {/* <hr style={{ height: '0.1rem' }} /> */}
                <div className="mt-2 w-100" style={{ minWidth: 0, overflow: "hidden" }}>
                    {/* <table className="table table-sm align-middle mb-0 w-100" style={{ fontSize: "12px", tableLayout: "fixed", width: "100%", overflowWrap: "anywhere" }}> */}
                    <Table
                        style={{
                            width: "100%",
                            height: "auto",
                            tableLayout: "auto",
                            marginBottom: "0px",
                            borderCollapse: "separate",
                            borderSpacing: "0px",
                            borderRadius: "7px",
                            fontSize: "12px",
                        }}
                        className="table table-sm align-middle mb-0 w-100"
                    >
                        {tableHeader()}
                        <tbody className="position-relative">
                            {
                                dataLength > 0 ?
                                    tableBody()
                                    :
                                    <td
                                        colSpan="14"
                                        style={{ textAlign: "center", color: "gray" }}
                                    >
                                        <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ position: "absolute", left: "28%" }}
                                        >
                                            <img
                                                src={nodata}
                                                alt=""
                                                style={{ width: "17rem", marginTop: "0" }}
                                            />
                                        </div>
                                    </td>
                            }
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card >


    )
}